import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';
import { TENANT_MODE, TENANT_SLUG } from 'src/core/environments';
import { TranslocoHttpLoader } from 'src/core/i18n';
import { jwtInterceptor } from 'src/core/interceptors';
import { CustomTitleStrategy, LocalStorageService } from 'src/core/services';
import { BASE_PATH as NESTJS_BACKEND_BASE_PATH } from 'src/generated/api/nestjs-backend';
import { environment } from 'src/main/environments';

export const coreConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([jwtInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['en', 'de', 'it'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        failedRetries: 0,
      },
      loader: TranslocoHttpLoader,
    }),
    importProvidersFrom(
      LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
      MarkdownModule.forRoot({
        loader: HttpClient,
        markedOptions: {
          provide: MARKED_OPTIONS,
          useValue: {
            gfm: true,
            breaks: true,
            pedantic: true,
          },
        },
      }),
    ),
    {
      provide: LOCALE_ID,
      useFactory: (localStorageService: LocalStorageService) => {
        const locale = localStorageService.getLocale();
        if (locale) return locale;

        const userLocale =
          localStorageService.getAuthentication()?.user?.locale;
        if (userLocale) return userLocale;

        return 'en-US';
      },
      deps: [LocalStorageService],
    },
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
    {
      provide: NESTJS_BACKEND_BASE_PATH,
      useValue: environment.nestJSBackendUrl,
    },
    { provide: TENANT_MODE, useValue: environment.tenantMode },
    { provide: TENANT_SLUG, useValue: environment.tenantSlug },
  ],
};
